import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import Button from '../../components/Button/Button';
import styles from './NotFound.module.css';

const NotFound = () => {
  return (
    <div className={styles.notFound}>
      <div className={styles.container}>
        <div className={styles.content}>
          <span className={styles.errorCode}>404</span>
          <SectionTitle title="Page Not Found" subtitle="Oops!" align="center" />
          <p className={styles.message}>
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <Link to="/">
            <Button variant="primary" size="large">Go to Homepage</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;